import { FC } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

interface Props {
  onClose: () => void;
}

export const PaymentsScheduleListInfoModal: FC<Props> = ({ onClose }) => {
  return (
    <Stack pt="10px" spacing="14px">
      <Text fontSize="14px" textAlign="center">Нажмите на платеж, чтобы увидеть детали</Text>

      <Button onClick={onClose} mt="22px">Понятно</Button>
    </Stack>
  );
};
